import React from 'react';
import DatePickerInput from './DatePickerInput';

const DatePickerInputContainer = ({ onChange, ...restProps }) => {
  const handleChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <DatePickerInput
      {...restProps}
      readOnlyInput={true}
      onChange={handleChange}
    />
  );
};

export default React.memo(DatePickerInputContainer);
